import { fresh } from './engine.ts';
import type { Save } from './types.ts';

export const STORAGE_KEY = 'luckystack-save-v3';

export function migrate(input: unknown): Save {
  const base = fresh();
  if (!input || typeof input !== 'object') return base;
  const value = input as Record<string, any>;
  if (!value.wallets || !['creative','regular','competitive'].every(m => value.wallets[m])) return base;
  const result = { ...base, ...value, version: 3 } as Save;
  for (const mode of ['creative','regular','competitive'] as const) {
    result.wallets[mode] = { ...base.wallets[mode], ...value.wallets[mode] };
    result.wallets[mode].rounds = Array.isArray(value.wallets[mode].rounds) ? value.wallets[mode].rounds : [];
    result.wallets[mode].stats = { ...base.wallets[mode].stats, ...value.wallets[mode].stats };
    result.wallets[mode].stats.byGame = value.wallets[mode].stats?.byGame ?? {};
  }
  result.achievements = Array.isArray(value.achievements) ? value.achievements.map((a:any) => typeof a === 'string' ? { id:a, completedAt:Date.now() } : a).filter((a:any)=>a?.id) : [];
  result.milestones = Array.isArray(value.milestones) ? value.milestones : [];
  result.settledRounds = Array.isArray(value.settledRounds) ? value.settledRounds : [];
  result.blackjackRules={...base.blackjackRules,...(value.blackjackRules??{})};
  result.creativeFundLimit=Number.isFinite(value.creativeFundLimit)&&value.creativeFundLimit>0?Math.min(100_000,value.creativeFundLimit):base.creativeFundLimit;
  result.balancePoints = Array.isArray(value.balancePoints) ? { creative:[5000], regular:value.balancePoints, competitive:[5000] } : { ...base.balancePoints, ...(value.balancePoints ?? {}) };
  result.lastSeenAt = Date.now();
  return result;
}

export function loadSave(storage: Pick<Storage,'getItem'> = localStorage) {
  try { return migrate(JSON.parse(storage.getItem(STORAGE_KEY) || storage.getItem('luckystack-save-v2') || 'null')); }
  catch { return fresh(); }
}
export function saveGame(save: Save, storage: Pick<Storage,'setItem'> = localStorage) { storage.setItem(STORAGE_KEY, JSON.stringify(save)); }
